import React from "react";
import Spinner from '../Components/spinner';
import classnames from "classnames";
import { Link } from "react-router-dom";
import { Events, animateScroll as scroll, scrollSpy } from 'react-scroll'

import { Button,Card,CardBody,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Modal,
  Form,
  Input,
  InputGroup,
  Collapse,
  // InputGroupAddon,
  // InputGroupText,
  // Label,
  FormGroup,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,Container,Row,Col} from "reactstrap";
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import RangeSlider from 'react-bootstrap-range-slider';// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar";
import Footer from "components/Footer/Footer.js";
import AceEditor from "react-ace";
import CompilerApi from '../api/CompilerApi';
import AlertDismissable from '../Components/AlertDismissable';
import OutputBox from '../Components/OutputBox';
import "ace-builds/src-noconflict/mode-jsx";
import "ace-builds/src-min-noconflict/ext-searchbox";
import "ace-builds/src-min-noconflict/ext-language_tools";
import Fade from 'react-reveal/Fade';



const languages = [{"name":"C","lang":"c_cpp"},{"name":"C++","lang":"c_cpp"},{"name":"Python","lang":"python"},{"name":"Java","lang":"java"}];


const darkthemes = [
  "ambiance",
  "monokai",
  "cobalt",
  "chaos",
  "dracula",
  "mono_industrial",
  "twilight",
  "solarized_dark",
  "terminal",
  "gruvbox",
  "clouds_midnight"
];
const lighthemes = [
  "github",
  "tomorrow",
  "clouds",
  "chrome",
  "crimson_editor",
  "eclipse",
  "dreamweaver",
  "kuroir",
  "xcode",
  "textmate",
  "solarized_light",
];
languages.forEach(lang => {
  require(`ace-builds/src-noconflict/mode-${lang.lang}`);
  require(`ace-builds/src-noconflict/snippets/${lang.lang}`);
});

darkthemes.forEach(theme => require(`ace-builds/src-noconflict/theme-${theme}`));
lighthemes.forEach(theme => require(`ace-builds/src-noconflict/theme-${theme}`));


// hotkeys('ctrl+enter', function(event, handler){
//   // Prevent the default refresh event under WINDOWS system
//   event.preventDefault();
//   alert('hi');
//   console.log(handler);
// });

class LandingPage extends React.Component {
  componentDidMount() {
    scroll.scrollToTop();
    document.body.classList.toggle("/");
    window.addEventListener("scroll", this.changeColor);
    window.addEventListener("keypress", this.handleKeyboard, false);

  }

  componentWillUnmount() {
    document.body.classList.toggle("/");
    window.removeEventListener("scroll", this.changeColor);
  }

  handleRun(event) {
    this.setState({showSpinner:true});
    event.preventDefault();
    var code = this.state.code;
    var userinput = this.state.userinput;
    var lang=this.state.mode;
    CompilerApi.run(code,lang,userinput)
      .then((res) => {
        this.setData(res);
      })
      .catch((error) => {
        this.setState({showSpinner:false});
        console.log(error);
      });
  }

  changeColor = () => {
    if (
      document.documentElement.scrollTop > 100 ||
      document.body.scrollTop > 100
    ) {
      this.setState({
        color: "primary"
      });
    } else if (
      document.documentElement.scrollTop < 100 ||
      document.body.scrollTop < 100
    ) {
      this.setState({
        color: "navbar-transparent"
      });
    }
  };
  setData(data){
    if(data.exitCode===1){
      this.setState({errorType:data.errorType});
      this.setState({showSpinner:false});
    }
    this.setState({stderr:data.stderr});
    this.setState({exitCode:data.exitCode});
    this.setState({stdout:data.stdout});
    this.setState({userinput:data.input});
    this.setState({showSpinner:false});
    if(this.state.formModal===true){
      this.toggleModal("formModal");
    }
    this.scrollTo();
  }
  onChange(newValue) {
    this.setState({
      value: newValue
    });
    this.setState({
      code: newValue
    });
  }
  setTheme(e) {
    this.setState({
      theme: e.target.value
    });
  }
  setMode(e) {
    this.setState({
      mode: e.target.value
    });
  }
  handleInput(e){
    this.setState({
      userinput: e.target.value
    });
  }
  setFontSize(e) {
    this.setState({
      fontSize: parseInt(e.target.value, 10)
    });
  }
  scrollTo() {
    scroll.scrollTo(600);
  }
  toggleModal = modalState => {
    this.setState({
      [modalState]: !this.state[modalState]
    });
  };

  handleKeyboard(e){
    if(e.ctrlKey===true && e.keyCode===10){
      this.quickRun();
    }else if(e.shiftKey===true && e.code==="Enter"){
      this.toggleModal("formModal");
    }
  }
  quickRun() {
    this.setState({showSpinner:true});
    var code = this.state.code;
    var userinput = this.state.userinput;
    var lang=this.state.mode;
    CompilerApi.run(code,lang,userinput)
      .then((res) => {
        this.setData(res);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  toggleCollapse = () => {
    document.documentElement.classList.toggle("nav-open");
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  onCollapseExiting = () => {
    this.setState({
      collapseOut: "collapsing-out"
    });
  };
  onCollapseExited = () => {
    this.setState({
      collapseOut: ""
    });
  };
  constructor(props) {
    super(props);
    this.state = {
      formModal: false,
      code:'',
      value:'',
      theme: "cobalt",
      mode: "python",
      errorType:"",
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      fontSize: 18,
      showGutter: true,
      showPrintMargin: false,
      highlightActiveLine: true,
      enableSnippets: true,
      showLineNumbers: true,
      stderr:"",
      stdout: "",
      color: "navbar-transparent",
      exitCode: 0,
      userinput:"",
      showSpinner:false,
      collapseOut:false
    };

    this.handleRun = this.handleRun.bind(this);
    this.setTheme = this.setTheme.bind(this);
    this.setMode=this.setMode.bind(this);
    this.onChange = this.onChange.bind(this);
    this.setFontSize = this.setFontSize.bind(this);
    this.handleInput=this.handleInput.bind(this);
    this.handleKeyboard=this.handleKeyboard.bind(this);
  }
  render() {
    if(this.state.showSpinner===true){
      return(
      <>
       <ExamplesNavbar />
          <div className="wrapper">
            <div className="page-header">
            <img
                alt="..."
                className="mainbg"
                src={require("assets/custom/bg.jpg")}
              />
              <div className="content-center">
                <Row  className="row-grid">
                  <Col md="12">
                    <Spinner/>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Footer/>  
      </>
      );
    }
    else{
      return (
      <>
        <Navbar className={"fixed-top " + this.state.color} color-on-scroll="100" expand="lg">
          <Container>
            <div className="navbar-translate">
              <NavbarBrand to="/" id="navbar-brand" tag={Link}>
                <span>• EDICODETOR •</span>
              </NavbarBrand>
              <button aria-expanded={this.state.collapseOpen} className="navbar-toggler navbar-toggler" onClick={this.toggleCollapse}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <Collapse className={"justify-content-end " + this.state.collapseOut} navbar isOpen={this.state.collapseOpen} onExiting={this.onCollapseExiting} onExited={this.onCollapseExited}>
              <div className="navbar-collapse-header">
                <Row>
                  <Col className="collapse-brand" xs="6">
                    •EDICODETOR•
                  </Col>
                  <Col className="collapse-close text-right" xs="6">
                    <button
                      aria-expanded={this.state.collapseOpen}
                      className="navbar-toggler"
                      onClick={this.toggleCollapse}
                    >
                      <i className="tim-icons icon-simple-remove" />
                    </button>
                  </Col>
                </Row>
              </div>
              <Nav navbar>
                <UncontrolledDropdown nav>
                  Theme:
                  <DropdownToggle aria-expanded={false} aria-haspopup={true} caret color="default" data-toggle="dropdown" id="navbarDropdownMenuLink" nav>
                    <p>{this.state.theme}</p>
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink" style={{overflowY:"scroll",maxHeight:'30pc'}}>
                    <span style={{fontWeight:"bold" , paddingLeft:'10px'}}>Dark Themes</span>
                    {darkthemes.map(lang => (
                      <DropdownItem key={lang} value={lang} onClick={this.setTheme}>
                        {lang}
                      </DropdownItem>
                    ))}
                    <span style={{fontWeight:"bold" , paddingLeft:'10px'}}>Light Themes</span>
                    {lighthemes.map(lang => (
                      <DropdownItem key={lang} value={lang} onClick={this.setTheme}>
                        {lang}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav>
                  Language:
                  <DropdownToggle aria-expanded={false} aria-haspopup={true} caret color="default" data-toggle="dropdown" id="navbarDropdownMenuLink" nav>
                    <p>{this.state.mode}</p>
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
                    {languages.map(lang => (
                      <DropdownItem key={lang.name} value={lang.lang} onClick={this.setMode}>
                        {lang.name}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
                <NavItem>
                  <NavLink>
                    <span><b>Font Size:</b></span> 
                  </NavLink>
                </NavItem>
                <RangeSlider value={this.state.fontSize} variant="info" onChange={this.setFontSize} min="14" max="40" step="2"/>
                <NavItem>
                  <Button className="btn-tooltip" color="warning" onClick={() => this.toggleModal("formModal")} id="userinput" >
                    <i className="tim-icons icon-triangle-right-17"></i>
                  </Button>
                  <UncontrolledTooltip delay={0} placement="top" target="userinput">
                    Provide User Input & RUN
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <Modal modalClassName="modal-black" isOpen={this.state.formModal} toggle={() => this.toggleModal("formModal")}>
                    <div className="modal-header justify-content-center">
                      <button className="close" onClick={() => this.toggleModal("formModal")}>
                        <i className="tim-icons icon-simple-remove text-white" />
                      </button>
                      <div className="text-muted text-center ml-auto mr-auto">
                        <h3 className="mb-0">Enter Input</h3>
                      </div>
                    </div>
                    <div className="modal-body">
                      <Form role="form">
                        <FormGroup className="mb-3">
                          <InputGroup className={classnames("input-group-alternative", {"input-group-focus": this.state.emailFocus })}>
                            <Input placeholder="User Input" onChange={this.handleInput} type="textarea"/>
                          </InputGroup>
                        </FormGroup>
                        <div className="text-center">
                          <Button className="my-4" color="warning" type="button" onClick={this.handleRun}>
                            <i className="tim-icons icon-triangle-right-17"></i>
                            Run
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </Modal>
                </NavItem>
                <NavItem>
                  <NavLink style={{fontSize:'1.4em', fontFamily:'Volkron,serif'}} to="/" tag={Link}>
                      <i className="fa fa-home" id="home" aria-hidden="true"></i>
                  </NavLink>
                  <UncontrolledTooltip delay={0} placement="top" target="home">
                      Home
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink to='/report' tag={Link} style={{fontSize:'1rem'}}>
                    <i id="bug" className="tim-icons icon-settings"></i>
                  </NavLink>
                  <UncontrolledTooltip placement="top" target="bug">
                    Report Bug/Give Suggestions.
                  </UncontrolledTooltip>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
        <div className="wrapper" >
          <div className="page-header">
            <img alt="..." className="mainbg" src={require("assets/custom/bg.jpg")}/>
            <div className="content-center">
              <Row className="row-grid">
                <Col md="12">
                  <Fade big>
                    <h4>Code Editor</h4>
                      <AceEditor
                          ref="aceEditor"
                          placeholder="Code here...."
                          mode={this.state.mode}
                          theme={this.state.theme}
                          name="blah2"
                          onChange={this.onChange}
                          value={this.state.value}
                          code={this.state.code}
                          fontSize={this.state.fontSize}
                          width="inherit"
                          showPrintMargin={this.state.showPrintMargin}
                          showGutter={this.state.showGutter}
                          highlightActiveLine={this.state.highlightActiveLine}
                          setOptions={{
                            useWorker: true,
                            enableBasicAutocompletion: this.state.enableBasicAutocompletion,
                            enableLiveAutocompletion: this.state.enableLiveAutocompletion,
                            enableSnippets: this.state.enableSnippets,
                            showLineNumbers: this.state.showLineNumbers,
                            tabSize: 2
                          }}
                        />
                  </Fade>
                </Col>
              </Row>
            </div>              
          </div>              
          <section className="section">
            <Row className="row-grid" style={{display:'contents'}}>
              <Col md="12">
                <Card className="scroll horizontal-scrollable" style={{background: 'black'}} >
                  <CardBody>
                    <i style={{color:'green',fontSize:'1.2rem'}} className="fa fa-terminal" aria-hidden="true"></i>
                    <h2>
                      <small>
                        <OutputBox show={this.state.exitCode === 0} message={this.state.stdout} />
                      </small>
                    </h2>
                    <AlertDismissable show={this.state.exitCode !== 0} message={this.state.stderr} errorType={this.state.errorType}/>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </section>
        </div>        
        <Footer />
      </>
      );
    }
  }
}

export default LandingPage;
